<template>
  <form @submit.prevent="addBundleToCart" novalidate>
    <slot></slot>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import { TablescapeContext, TablescapeEvent } from "@tablescape/context";

export default {
  name: "product-bundle-single-form",
  props: {
    bundletitle: String,
    bundleprice: [Number, String],
  },
  computed: {
    ...mapGetters({
      getProperties: "metafields/getProperties",
    }),
  },
  methods: {
    async addBundleToCart() {
      const checkbox = document.querySelector(
        'input[data-select-id="id"][type="radio"]:checked'
      );
      const variantIds = checkbox.dataset.vid.split("|");
      const items = variantIds.map((variant) => ({
        attributes: [...(this.getProperties(variant) ?? [])],
        id: variant,
        quantity: 1,
      }));
      TablescapeContext.emit(TablescapeEvent.TOGGLE_CART, {
        ui: {
          cartDrawerOpen: true,
          cartDrawerUserToggled: false,
          giftNoteDrawerOpen: false,
          productVariantDrawerOpen: false,
        },
      });
      TablescapeContext.emit(TablescapeEvent.ADD_BUNDLE_TO_CART, {
        cart: {
          lines: items,
          bundleProduct: {
            title: this.bundletitle,
            price: this.bundleprice,
          },
        },
      });
    },
  },
  async created() {
    this.$store.dispatch("metafields/fetchMeta");
  },
};
</script>
